module.exports = __webpack_public_path__ + "img/laboratorio_16-9.cec1111f.jpg";